// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"dd1b8971","678":"dd1b8971","701":"dd1b8971"}[chunkId] + ".chunk.css";
};